import src from "IMAGE";
export default { src, width: 395, height: 250, blurWidth: 0, blurHeight: 0};
